export const GLOBAL_MARGIN_HORIZONTAL = 4;
export const HEADER_HEIGHT = 80;

export const CONTACT_US_URL = 'https://syntraxis.neberox.com/contact.html';
